import {
  ChangeDetectionStrategy,
  Component,
  Inject,
  OnInit,
  Output,
} from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { Observable, Observer, tap } from 'rxjs';

import { UntilDestroy, untilDestroyed } from '@ngneat/until-destroy';

interface DialogData {
  extraClass: string;
  accepting?: Observable<boolean>;
  accepted?: Observable<boolean>;
  acceptButton?: () => void;
  sendData?: () => void;
}

@UntilDestroy()
@Component({
  selector: 'fz-updated-terms-dialog',
  templateUrl: './updated-terms-dialog.component.html',
  styleUrls: ['./updated-terms-dialog.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class UpdatedTermsDialogComponent implements OnInit {
  constructor(
    public dialogRef: MatDialogRef<UpdatedTermsDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: DialogData,
  ) {
    if (data === null) {
      this.data = { extraClass: '' };
    }
    this.dialogRef.backdropClick().subscribe(() => {
      // add required class to add shake animation
      this.data.extraClass = 'modal_focus';

      setTimeout(() => {
        // clear class
        this.data.extraClass = '';
      }, 1000);
    });
  }

  ngOnInit(): void {
    //
    if (this.data && this.data.accepted) {
      this.data.accepted
        .pipe(
          untilDestroyed(this),
          tap((accepted) => {
            if (accepted) {
              this.dialogRef.close(true);
            }
          }),
        )
        .subscribe();
    }
  }

  onAcceptTermsAndConditions(event: MouseEvent) {
    // stop event propagation
    event.preventDefault();

    if (this.data && this.data.acceptButton) {
      this.data.acceptButton();
    }
  }
}
